module.exports = __webpack_public_path__ + "closeButton.png?be4492c0adea56941d31c9be4b7b7e98";


//////////////////
// WEBPACK FOOTER
// ./assets/img/closeButton.png
// module id = 60
// module chunks = 0